import { createLogic } from "redux-logic";
import * as ActionTypes from "../../actions/actionTypes";
import * as userActions from "../../actions/userActions";

const loginSuccessLogic = createLogic({
	type: ActionTypes.LOGIN_SUCCESS,
	latest: true,
	// eslint-disable-next-line no-unused-vars
	process({ getState, action }, dispatch, done) {
		dispatch(userActions.getUser());
		done();
	},
});

export default [loginSuccessLogic];
